import { useEffect, useRef } from 'react'
import { gsap, Power1 } from 'gsap'
import styles from './Assignment.module.scss'
import TitleFlex from 'components/services/commons/TitleFlex'

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { useMediaQuery } from '@material-ui/core'
gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TweenVars = {
  y: '50',
  duration: 0.5,
  opacity: 0,
  ease: Power1.easeOut,
}

interface Props {
  list: {
    title: string
    text: string
  }[]
  rowCount?: number
}

const Assignment: React.FC<Props> = ({ list, rowCount = 3 }) => {
  const timeline = gsap.timeline()
  const itemsRef = useRef<HTMLLIElement[]>([])

  useEffect(() => {
    timeline.from(itemsRef.current, {
      ...tweenVars,
      stagger: 0.3, // 各要素のアニメーションを0.3秒ずつ遅らせて実行
    })

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.Assignment_container',
      start: 'top 90%',
      toggleActions: 'play none none play',
    })

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
      timeline.kill()
    }
  }, [])

  return (
    <section className={styles.wrapper}>
      <div className={`${styles.inner}`}>
        <TitleFlex sectionTitle={{ title: 'What we could achieve', sub_title: '解決できる課題' }} />
        <ul className={`${styles.assignment_list} Assignment_container`}>
          {list.map((item, index) => (
            <li
              key={index}
              ref={(el) => (itemsRef.current[index] = el)}
              className={`${styles.assignment_item} Assignment_item0${index + 1}`}
            >
              <div className={styles.assignment_item_check}></div>
              <p className={styles.assignment_item_title}>{item.title}</p>
              <p className={styles.assignment_item_text}>{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Assignment
